import { refreshToken as refreshTokenApi } from "../services/auth/api";

let scheduleRefreshTokenId: NodeJS.Timeout
let isRefreshing = false

export interface TokenPayload {
    exp: number,
    authorization: {
        permissions: [
            {
                claims: {
                    CODIGO_USUARIO: string[],
                    LOGIN_USUARIO: string[],
                    NOME_USUARIO: string[],
                    DATA_HORA_ULTIMO_ACESSO: Date[],
                    TIPO_USUARIO: string[],
                    ACESSO_EXTERNO: string[],
                    EMAIL_USUARIO: string[],
                    CODIGO_CLIENTE: number[],
                    CODIGO_FILIAL: number[],
                    CNPJ_CLIENTE: string[];
                    TIPO_EMBARCADORA: string[],
                    CODIGO_EMBARCADORA: number[],
                    POSSUI_VINCULO_TRANSPORTADOR_EXTERNO: string[],
                    CODIGO_TRANSPORTADOR: string[],
                }
            }
        ]
    }
}

export const getTokenPayload = (token: string): TokenPayload => {
    return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString());
};

const renewToken = (refreshToken: string) => {
    if (isRefreshing) {
        return;
    }

    isRefreshing = true;

    refreshTokenApi(refreshToken).then(() => {
        isRefreshing = false;
    }).catch(err => {
        console.log(err)
        window.location.reload();
    })
}

const scheduleRefreshToken = (accessToken: string, refreshToken: string) => {
    const payload = getTokenPayload(accessToken)
    const expires = new Date(payload.exp * 1000)

    const diff = expires.getTime() - Date.now();

    // caso for menor que 1 minuto efetua o refresh agora
    if (diff < 1000) {
        renewToken(refreshToken)
        return
    }

    // define novo prazo para renovar o token
    expires.setMinutes(expires.getMinutes() - 1)

    const timeToWait = expires.getTime() - Date.now();

    scheduleRefreshTokenId = setTimeout(async () => {
        await renewToken(refreshToken)
    }, timeToWait)
}

export const scheduleAccessTokenRefresh = async (accessToken: string, refreshToken: string) => {
    if (scheduleRefreshTokenId) {
        clearTimeout(scheduleRefreshTokenId)
    }

    await scheduleRefreshToken(accessToken, refreshToken)
}
